import React, { useMemo } from 'react';

export interface PointerProps extends React.HTMLAttributes<HTMLDivElement> {
    prefixCls?: string;
    top?: string;
    left: string;
    angle?: number;
}

const BOXSHADOW =
    'rgb(255 255 255) 0px 0px 0px 1.5px, rgb(0 0 0 / 30%) 0px 0px 1px 1px inset, rgb(0 0 0 / 40%) 0px 0px 1px 2px';

export const Pointer = ({ className, left, top, angle, style, prefixCls }: PointerProps): JSX.Element => {
    const styleWarp: React.CSSProperties = {
        ...style,
        position: 'absolute',
        top,
        left,
    };
    return useMemo(
        () => (
            <div className={`${prefixCls}-pointer ${className || ''}`} style={styleWarp}>
                <div
                    className={`${prefixCls}-fill`}
                    style={{
                        width: 8,
                        height: 8,
                        transform: 'translate(-4px, -4px)',
                        boxShadow: BOXSHADOW,
                        borderRadius: '50%',
                        backgroundColor: 'rgba(0, 0, 0, 0.4)',
                    }}
                >
                    {/* <div
            style={{
              inset: 0,
              borderRadius: '50%',
              position: 'absolute',
            }}
          /> */}
                </div>
            </div>
        ),
        [top, left, angle, className, prefixCls],
    );
};
